class CustomPagination {
    /**
     * @type {HTMLElement}
     */
    element;

    /**
     * @type {HTMLElement[]}
     */
    buttons;

    isProcess = false;

    constructor(el) {
        if (!el) {
            return;
        }

        this.element = el;
        this.buttons = Array.from(this.element.querySelectorAll('[data-page]'));
        //this.productFilters = 
        this.addListeners();
        //console.log(this);
    }

    addListeners() {
        this.buttons.forEach(button => {
            button.addEventListener('click', (e) => {
                if (!window.productFilters) {
                    return;
                }
                
                e.preventDefault();
                const propFilters = window.innerWidth < 768 ? window.mobileFilters : window.productFilters;
                
                if (button.dataset.page === 'next') {
                    this.processToPage(propFilters.controller.paged + 1);
                    return;
                }

                if (button.dataset.page === 'prev') {
                    this.processToPage(propFilters.controller.paged - 1);
                    return;
                }

                this.processToPage(Number(button.dataset.page));
            });
        });

        addEventListener("popstate", (e) => {
            location.reload(true);
        });
    }

    processToPage(page) {
        const propFilters = window.innerWidth < 768 ? window.mobileFilters : window.productFilters;
        if (!propFilters || this.isProcess) {
            return;
        }

        const url_parts = window.location.href.split('?');
        const url_path = url_parts[0].split('page')[0];
        const url = new URL(`${url_path}page/${page}/${window.location.search}`);

        window.history.pushState(url.toString(), '', url.toString());

        this.isProcess = true;
        this.element.classList.add('loading');
        propFilters.controller.paged = page;
    }
};

(() => {
    const initPaginations = () => {
        const paginations = Array.from(document.querySelectorAll('[data-pagination]'));
        paginations.forEach(p => {
            if (p.inited) {
                return;
            }
            p.inited = true;
            new CustomPagination(p);
        });
    };

    window.initPaginations = initPaginations;
    initPaginations();
})();
